import type { SearchResult } from "@mirage/service-dbx-api/service/search";
import type { Recommendation } from "@mirage/shared/search/recommendation";
import type { TimeAgoStringConfig } from "@mirage/shared/util/time";
import { getTimeAgoString } from "@mirage/shared/util/time";
import i18n from "@mirage/translations";

export interface SourceRowTimeConfig {
  timeAgo?: TimeAgoStringConfig;
  hidePrefix?: boolean; // hide prefix text (e.g. "modified") default to false
}

export function getTimeString(
  updatedMs: number | null | undefined,
  config?: SourceRowTimeConfig,
) {
  if (!updatedMs) {
    return undefined;
  }
  const timeAgo = getTimeAgoString(updatedMs, config?.timeAgo);
  if (config?.hidePrefix) {
    return timeAgo;
  }
  return i18n.t("updated_ago", {
    timeAgo,
  });
}

/**
 * Helper function to get formatted "updated ago" string from mirage result
 * Falls back to updatedAtMs if providerUpdateAtMs doesn't exist
 */
export const getUpdatedAgoString = (
  mirageResult: SearchResult | Recommendation | null,
): string | null => {
  const timestamp =
    mirageResult?.providerUpdateAtMs ||
    (mirageResult && "updatedAtMs" in mirageResult
      ? mirageResult.updatedAtMs
      : null);
  return timestamp
    ? i18n.t("updated_ago", {
        timeAgo: getTimeAgoString(timestamp),
      })
    : null;
};
